import { Alert, Button, Card, CardContent, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { PageHeader } from "@components/navigation/PageHeader";

export function UnavailablePage({ title }: { title: string }) {
  return (
    <>
      <PageHeader title={title} />
      <Card>
        <CardContent>
          <Alert severity="info">
            This module is scheduled for the next implementation phase. No
            server operation has been simulated.
          </Alert>
          <Typography color="text.secondary" sx={{ mt: 2 }}>
            The navigation and permission boundary are active, but the required
            production UI and API integration are not part of the first
            implementation scope.
          </Typography>
          <Button component={Link} to="/dashboard" sx={{ mt: 2 }}>
            Return to dashboard
          </Button>
        </CardContent>
      </Card>
    </>
  );
}
